import React, { FC, useEffect, useRef, useState } from 'react';
import { LottieLoader, LottieOptions } from '../../../../../../../form/ui/lottie.loader';
import accuracy1Data from '../../assets/accuracy1.json';
import accuracy2Data from '../../assets/accuracy2.json';
import accuracy3Data from '../../assets/accuracy3.json';
import accuracy4Data from '../../assets/accuracy4.json';

export const ProgressPicture: FC<{ step: number }> = ({ step }) => {
    const [isAnimationStopped, setIsAnimationStopped] = useState(true);
    const imageContainerRef = useRef<HTMLDivElement | null>(null);

    const stepsAnimationData: Record<number, any> = {
        1: accuracy1Data,
        2: accuracy2Data,
        3: accuracy3Data,
        4: accuracy4Data,
    };

    const animOptions: LottieOptions = {
        loop: false,
        autoplay: false,
        animationData: stepsAnimationData[step],
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    const enableAnimationOnIntersection = () => {
        if (isAnimationStopped) {
            setIsAnimationStopped(false);
        }
    };

    useEffect(() => {
        const imageContainer = imageContainerRef.current;

        const observer = new IntersectionObserver(
            (entry) => {
                if (entry[0].isIntersecting) {
                    setTimeout(enableAnimationOnIntersection, 300);
                }
            },
            { threshold: 1.0 },
        );

        if (imageContainer) {
            observer.observe(imageContainer);
        }

        return () => {
            if (imageContainer) {
                observer.unobserve(imageContainer);
            }
        };
    }, []);

    return (
        <div ref={imageContainerRef}>
            <LottieLoader options={animOptions} isStopped={isAnimationStopped} height={130} width={197} />
        </div>
    );
};
